import D2C_TariffEarlyBird from './EarlyBird'

class D2C_TariffEarlyBirdAnnual extends D2C_TariffEarlyBird {
  isAnnual = true
  static objectType = 'tariffType'
  static active = false
  static hidden = true
  static tariffId = '59e83bd1d38e7200013bd0b1'
  static tariffTitle = 'EarlyBird annual'
  static order = 25
}

export default D2C_TariffEarlyBirdAnnual
